<template>
  <div class="activity">
    <div class="titles">
      <div class="city" @click="selectCity()">
        <span class="cityName">{{ cityname }}</span>
        <span class="sanjiao"></span>
      </div>
    </div>
    <div class="newUser">
      <img
        src="@/assets/images/activity/newUser.png"
        alt=""
        class="userNone"
        @click="goDraw()"
        v-if="!token"
      />
      <img
        src="@/assets/images/activity/userHave.png"
        alt=""
        class="userHave"
        v-if="token"
      />
    </div>
    <div class="activeTitle" v-if="!citycode||cityList.length > 0">
        <img src="@/assets/images/activity/left.png" alt="" />
        <p>城市专属活动更优惠</p>
        <img src="@/assets/images/activity/right.png" alt="" />
      </div>
    <div class="activeCoupon" v-if="cityList.length > 0" >
      <div class="list" v-for="(item, index) in cityList" :key="index">
        <div :class="item.PreferentialMode == 2 ? 'blue info' : 'info'">
          <div class="left">
            <div
              class="price"
              v-if="item.PreferentialMode == 1 || item.PreferentialMode == 3"
            >
              <span>¥</span>
              {{ item.DeductInfo.CutAmount }}
            </div>
            <div class="price" v-if="item.PreferentialMode == 2">
              {{ (item.DeductInfo.DiscountRate * 10).toFixed(1)
              }}<span>折</span>
            </div>
            <div v-if="item.DeductInfo.IsFiexd">
              {{
                "一口价"
              }}
            </div>
            <div v-if="!item.DeductInfo.IsFiexd">
              {{
                item.PreferentialMode == 1
                  ? "满减券"
                  : item.PreferentialMode == 2
                  ? "折扣券"
                  : "抵现券"
              }}
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="txt">
                <div class="tit">{{ item.OfferName }}</div>
                <div class="time">
                  {{
                    item.ValidBegin.split("T")[0].replace(/\-/g, "\.") +
                    "-" +
                    item.ValidEnd.split("T")[0].replace(/\-/g, "\.")
                  }}
                </div>
              </div>
              <div
                class="btn blue"
                @click="drawcoup(item.CanDrawCoupon, item.OfferID)"
                v-if="item.CanDrawCoupon"
              >
                立即领取
              </div>
              <div class="btn useblue" v-else>已领取</div>
            </div>
            <div class="bottom"  @click="detailInfos(index)">
              <div class="txt">详细信息</div>
              <div class="icon"  v-if="!isShows[index]"></div>
               <div class="icons" v-else></div>
            </div>
          </div>
        </div>
        <div class="detail" v-if="isShows[index]">
          <div class="txt" style="overflow:hidden;word-wrap: break-word;">{{ item.Comments }}</div>
        </div>
      </div>
    </div>
    <div class="tip" v-if="!citycode">
      <img src="@/assets/images/activity/locationFail.png" alt="" />
      <p>定位失败啦~</p>
      <p style="font-size: 14px">点击选择城市，领取专属优惠券吧~~</p>
    </div>
    <div class="activeCoupon">
      <div class="activeTitle">
        <img src="@/assets/images/activity/left.png" alt="" />
        <p>更多平台优惠券享不停</p>
        <img src="@/assets/images/activity/right.png" alt="" />
      </div>
      <div class="list" v-for="(item, index) in activeList" :key="index">
        <div :class="item.PreferentialMode == 2 ? 'blue info' : 'info'">
          <div class="left">
            <div
              class="price"
              v-if="item.PreferentialMode == 1 || item.PreferentialMode == 3&&!item.DeductInfo.IsFiexd"
            >
              <span>¥</span>
              {{ item.DeductInfo.CutAmount }}
            </div>
            <div
              class="price"
              v-if="item.DeductInfo.IsFiexd"
            >
              <span>¥</span>
              {{ item.DeductInfo.CutAmount }}
            </div>
            <div class="price" v-if="item.PreferentialMode == 2">
              {{ (item.DeductInfo.DiscountRate * 10).toFixed(1)
              }}<span>折</span>
            </div>
            <div v-if="!item.DeductInfo.IsFiexd">
              {{
                item.PreferentialMode == 1
                  ? "满减券"
                  : item.PreferentialMode == 2
                  ? "折扣券"
                  : "抵现券"
              }}
            </div>
            <div v-if="item.DeductInfo.IsFiexd">
              {{
                "一口价"
              }}
            </div>
          </div>
          <div class="right">
            <div class="top">
              <div class="txt">
                <div class="tit">{{ item.OfferName }}</div>
                <div class="time">
                  {{
                    item.ValidBegin.split("T")[0].replace(/\-/g, "\.") +
                    "-" +
                    item.ValidEnd.split("T")[0].replace(/\-/g, "\.")
                  }}
                </div>
              </div>
              <div
                class="btn blue"
                @click="drawcoup(item.CanDrawCoupon, item.OfferID)"
                v-if="item.CanDrawCoupon"
              >
                立即领取
              </div>
              <div class="btn useblue"  v-else>已领取</div>
            </div>
            <div class="bottom" @click="detailInfo(index)">
              <div class="txt">详细信息</div>
              <div class="icon" v-if="!isShow[index]"></div>
              <div class="icons" v-else></div>
            </div>
          </div>
        </div>
        <div class="detail" v-if="isShow[index]">
          <div class="txt" style="overflow:hidden;word-wrap: break-word;">{{ item.Comments }}</div>
        </div>
      </div>
      <div class="tip" v-if="activeList.length == 0">
        <img src="@/assets/images/activity/activeNone.png" alt="" />
        <p>暂无优惠活动~</p>
      </div>
    </div>
    
    <div class="gorent" @click="gorent()">立即租车</div>
    <div class="box"></div>
  </div>
</template>
<script>
import {
  // getActivityPlatformOffers,
  DrawCoupon,
  // getActivityOffers,
  getCouponList,
} from "@/utils/api";
import { resourceUrl, orderSource, imgUrl } from "@/utils/env";
export default {
  name: "activity",
  data() {
    return {
      isShow: [],
      isShows: [],
      couponlist: [],
      activeList: [],
      cityList: [],
      resourceUrl: resourceUrl,
      orderSource: orderSource,
      citycode: "",
      cityname: "",
      token: "",
      tipshow: false
    };
  },
  props: [],
  created() {
    
  },
  mounted() {
     setTimeout(()=>{
        window.getCityMessage = this.getCityMessage;
        this.citycode =localStorage.getItem("citycode")?localStorage.getItem("citycode"):"";
        this.cityname =localStorage.getItem("cityname")?localStorage.getItem("cityname"):"请选择";
        this.token = localStorage.getItem("token");
        this.init();
      },300);
      df.report({ method:"report",page:"coupon",event:"getCoupon"});
  },
  methods: {
    init() {
        this.activeList=[];
        this.cityList=[];
        setTimeout(async () => {
          let res = await getCouponList({
            data:{
              cityCode:this.citycode,
              bizchannel:0
            }
          });
          if (res.Code == 100) {
            for (let i = 0; i < res.Data.length; i++) {
              this.isShow.push(false);
              if(res.Data[i].IsGlobal){
                  this.activeList.push(res.Data[i]);
              }else{
                  this.cityList.push(res.Data[i]);
              }
            }
          }
        }, 500);
    },
    selectCity() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.openPage.postMessage(
          JSON.stringify({ type: "app", url: "DFCityListViewController?" })
        );
      } else if (orderSource == 16) {
        dfpanda.selectCity();
      }
    },
    getCityMessage(res){
        this.cityname=res.cityname;
        this.citycode =res.citycode;
        this.init();
        localStorage.setItem("cityname",res.cityname);
        localStorage.setItem("citycode",res.citycode);
    },
     //领取优惠券
    async drawcoup(isdraw, offerid) {
      let res = await DrawCoupon({
        data: { offerId: offerid, orgID: 0,bizchannel:0 },
      });
      if (res.Code == 100) {
        this.flexible.showToast({content:'领取成功,立即去租车吧~'});
        //this.init(); // 重新加载优惠券列表
        for(var i in this.cityList){
          if(offerid==this.cityList[i].OfferID){
            this.cityList[i].CanDrawCoupon=false;
          }
        }
         for(var i in this.activeList){
          if(offerid==this.activeList[i].OfferID){
            this.activeList[i].CanDrawCoupon=false;
          }
        }
        df.report({ method:"report",page:"coupon",event:"DrawCoupon",offerId:offerid});
         if(this.orderSource==17){
          window.webkit.messageHandlers.updateMemberInfo.postMessage(null);
        }else if( this.orderSource==16 ){
          dfpanda.updateMemberInfo();
        }
      }
       if( res.Code==17007 ){
          this.flexible.showToast({
            content: '请登录/注册！',
            duration: 1200,
            success: ()=>{
              // console.log('调用原生方法跳转登录');
              if( orderSource==17 ){
                window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
              } else if ( orderSource==16 ){
                dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
              }
            }
          });
        }else{
          this.flexible.showToast({
            content:res.Message
          })
        }
    },
    //新人领取
    goDraw() {
      if (orderSource == 17) {
        window.webkit.messageHandlers.openPage.postMessage(
          JSON.stringify({ type: "app", url: "/LonginActivity"})
        );
      } else if (orderSource == 16) {
        dfpanda.openPage(
          JSON.stringify({ type: "app", url: "/app/LonginActivity"})
        );
      }
    },
    gorent() {
      df.report({ method:"report",page:"coupon",event:"DrawCouponPageToRent"});
      if(this.orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }else if( this.orderSource==16 ){
        dfpanda.goHome();
      }
    },
    detailInfo(index) {
      let show = this.isShow[index];
      this.$set(this.isShow, index, !show);
    },
    detailInfos(index) {
      let show = this.isShows[index];
      this.$set(this.isShows, index, !show);
    }
  },
};
</script>
<style lang="scss" scoped type="text/scss">
.box{
  height:150px;
  width: 100%;
}
.titles {
  width: 100%;
  height: 300px;
  background-image: url("../assets/images/activity/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.city {
  width: 160px;
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 25px;
  border: 1px solid #fff;
  font-size: 26px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 80px auto;
}
.cityName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 140px;
}
.sanjiao {
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
  margin-top: 20px;
}
.newUser {
  width: 90%;
  background-color: #fff;
  height: 220px;
  margin-top:-100px;
}
.newUser img {
  width: 100%;
  height: 100%;
}
.activeTitle {
  display: flex;
  flex-direction: row;
  height: 32px;
  line-height: 32px;
  margin: 30px 110px;
  margin-bottom:0;
}
.activeTitle p {
  width: 320px;
  margin: 0 10px;
  color: #ff8307;
  font-size: 30px;
  font-weight: 500;
  font-family: Source Han Sans CN;
  text-align: center;
}
.activeCoupon {
  margin-top:10px;
}
.activeCoupon img {
  width: 58px;
  height: 22px;
  display: inline-block;
  margin-top: 5px;
}
.tip {
  text-align: center;
}
.tip img {
  width: 120px;
  height: 120px;
}
.tip p {
  color: #999999;
  font-size: 28px;
}
.gorent {
  width: 600px;
  height: 90px;
  background: #ff8307;
  opacity: 1;
  border-radius: 45px;
  text-align: center;
  line-height: 90px;
  color: #fff;
  font-size: 32px;
  position: fixed;
  box-shadow: 5px 5px 40px #888888;
  left:0;
  right:0;
  margin-left:auto;
  margin-right:auto;
  bottom:20px;
}
.activity {
  width: 100%;
  // padding-top:110px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #434343;
  .list {
    width: 680px;
    background: #fff;
    margin-bottom: 25px;
    font-size: 26px;
    margin-top:24px;
    .info {
      width: 100%;
      height: 170px;
      background: url(~@/assets/images/coupon_listbg01.png) no-repeat center;
      background-size: contain;
      display: flex;
      .left {
        width: 210px;
        height: 170px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        text-align: center;
        .price {
          font-size: 70px;
          span {
            font-size: 26px;
          }
        }
      }
      .right {
        font-size: 26px;
        width: 470px;
        height: 170px;
        padding: 0 23px 0 18px;
        .top {
          height: 125px;
          border-bottom: 1px solid #e2e2e2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time {
            font-size: 18px;
          }
          .btn {
            width: 125px;
            height: 40px;
            // text-align: center;
            // line-height: 40px;
            border: 1px solid #ff8307; /**no**/
            color: #ff8307;
            border-radius: 20px;
            font-size: 22px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .btn.blue {
            border: 1px solid #ff8307; /**no**/
            color: #fff;
            background: #ff8307;
          }
          .btn.useblue{
            border: 1px solid #D2D2D2;
            color:#999999;
            background:#D2D2D2;
          }
        }
        .bottom {
          height: 45px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #999999;
          font-size: 18px;
          .icon {
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 10px solid #000;
          }
          .icons {
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 10px solid #000;
          }
        }
      }
    }
    .info.blue {
      background: url("~@/assets/images/coupon_listbg02.png") no-repeat center;
      background-size: contain;
      .blue {
        border: 1px solid #1d8eff !important; /**no**/
        background: #1d8eff !important;
      }
      .useblue {
        border: 1px solid #1d8eff !important; /**no**/
        color: #1d8eff !important;
      }
    }
    .detail {
      border: 1px solid #e2e2e2; /**no**/
      border-top: none;
      padding: 20px 30px;
      font-size: 18px;
      color: #999999;
      overflow: hidden;
      
    }
  }
}
</style>
